// Loose runtime types for the per-area workspace bag.
// matter.workspace is `Record<string, unknown>` in types.ts because the
// shape varies by practice area. These helpers narrow at the access site
// so the per-area cards stay type-safe without bloating types.ts.

export interface I589Shape {
  sectionsComplete?: number;
  lastReviewedBy?: string;
  flags?: number;
  applicable?: boolean;
}

export interface DeclarationShape {
  version?: string;
  words?: number;
  signedOff?: boolean;
  themes?: string[];
}

export interface COIShape {
  sources?: number;
  latestDate?: string;
  primaryReports?: string[];
}

export interface DerivativeShape {
  name: string;
  relationship: string;
  age?: number;
}

export interface EADClockShape {
  i589FiledDate?: string;
  day150Eligible?: string;
  day180Eligible?: string;
  currentDay?: number;
  eadIssued?: string;
}

export interface ChargeShape {
  count: number;
  charge: string;
  grade?: string;
  maxJail?: string;
  maxFine?: string;
  immigrationImpact?: string;
}

export interface DefenseShape {
  theory?: string;
  strengthBars?: { factual?: number; legal?: number };
}

export interface BailShape {
  type?: string;
  amount?: number;
  conditions?: string[];
}

export interface CourtDateShape {
  date: string;
  event: string;
  venue?: string;
}

export interface ImmigrationImpactShape {
  riskLevel?: string;
  padillaAdvised?: string;
  parallelRemovalCase?: string;
}

export function pick<T>(bag: Record<string, unknown> | undefined, key: string): T | undefined {
  if (!bag) return undefined;
  const v = bag[key];
  return v as T | undefined;
}
